import { render, staticRenderFns } from "./conPtf.vue?vue&type=template&id=7019c712&scoped=true"
import script from "./conPtf.vue?vue&type=script&lang=js"
export * from "./conPtf.vue?vue&type=script&lang=js"
import style0 from "./conPtf.vue?vue&type=style&index=0&id=7019c712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7019c712",
  null
  
)

export default component.exports